<template>
  <div id="forgotpassword-view">
    <div
      class="modal fade"
      id="ResetModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-title text-center">
              <h4>Reset Password</h4>
            </div>
            <div class="d-flex flex-column text-center">
              <form>
                <b-alert show :variant="color" v-if="response_message != null">
                      {{ response_message }}
                    </b-alert>
                    <label for="username">Enter Your Email Address</label>
                    <div class="card-input-container username">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Enter Your Email Address"
                        v-model="email"
                        id="username"
                      />
                      <span class="text-danger" v-if="errors.email">{{
                        this.errors.email[0]
                      }}</span>
                    </div>
                    <div class="row">
                      <div class="col-8">
                        <span class="text-danger">{{ error_msg }}</span>
                      </div>
                    </div>
                    <div class="d-flex justify-content-center">
                      <button
                        @click="sendForgotPasswordMail"
                        type="button"
                        class="card-button btn btn-secondary my-4 col-5"
                      >
                        Send Email
                      </button>
                    </div>
              </form>
           
            
            
            </div>
          </div>
        
         
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MenuBar from "@/views/site/blocks/MenuBar";
export default {
  name: "ForgotpasswordView",
  components: {
    MenuBar,
  },
  data() {
    return {
      email: null,
      errors: [],
      response_message: null,
      color: "success",
      error_msg: null,
    };
  },
  created(){
      this.resetForm();
  },
  methods: {
    sendForgotPasswordMail() {
      //Save or update User Details
      this.errors = [];
      this.response_message = null;
      this.loader = true;
      let apiUrl = process.env.VUE_APP_URL + "customer/password/email";
      let method_type = "POST";
      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          email: this.email,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          if (data.status === true) {
            this.color = "success";
            this.response_message = data.message;
            this.email = null;
          } else if (data.status === false) {
            this.color = "danger";
            this.response_message = data.message;
          } else {
            this.errors = data.errors;
          }
        })
        .catch(function (err) {
          console.log("User Data", "Error : " + err.message, "error");
        });
    },
    resetForm(){
            this.response_message = null;
            this.email = null;

    },

  },
};
</script>
